import { useCallback, useState } from 'react';

// Which items are picked for a comparison. Deliberately in-memory, unlike the School/Union
// Finder's localStorage list: these are account-scoped records (applicants, offers, postings)
// that are re-read live when the comparison opens, so there's nothing worth persisting and no
// reason to leave someone's applicant ids sitting in the browser.
export function useCompareSelection() {
  const [ids, setIds] = useState([]);

  const isSelected = useCallback(id => ids.includes(id), [ids]);
  const toggle = useCallback(id => setIds(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])), []);
  const remove = useCallback(id => setIds(prev => prev.filter(x => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);

  return { ids, isSelected, toggle, remove, clear };
}
